import { CardNumberElement } from "@stripe/react-stripe-js";
import { getCsrfCookieName } from "helpers/gazetteGetCsrfCookieName";
import { getCookie } from "helpers/gazetteGetCookie";

export const processTransaction = async (
    form,
    body,
    routeURL,
    stripe,
    elements
) => {
    let formError;
    let success = false;

    const cardNumberElement = elements.getElement(CardNumberElement);
    const { token, error } = await stripe.createToken(cardNumberElement, form);

    const csrfCookieName = getCsrfCookieName();
    const csrftoken = getCookie({ name: csrfCookieName });

    if (error) {
        return {
            formError: error.message,
            success
        };
    }

    body.stripe_token = token.id;

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrftoken
        },
        body: JSON.stringify(body)
    };

    const response = await fetch(routeURL, options);
    const payload = await response.json();

    if (!payload) {
        formError = "Something went wrong.";
    } else if (payload.errors) {
        formError = payload.errors.error.message;
    } else {
        formError = false;
        success = true;
    }

    return {
        formError,
        success
    };
};
